<!-- TEMPLATE -->
<template>
  <div class="content" style="padding-top: 0px">
    <v-alert
      v-model="alertSuccess"
      dismissible
      border="left"
      elevation="2"
      dense
      text
      type="success"
      icon="mdi-checkbox-marked-circle"
    >
      Settings updated successfully
    </v-alert>
    <v-alert
      v-model="alertError"
      dismissible
      dense
      text
      type="error"
      border="left"
      elevation="2"
      icon="mdi-alert-circle"
    >
      There was an error. Please try again
    </v-alert>

    <div class="card">
      <div class="card-header">
        <h5 class="title">New Registered domains monitoring</h5>
        <h5>
          Select the domain from the dropdown and add the keyword you want to
          monitor
        </h5>
      </div>
    </div>

    <div v-for="(item, index_domain) in settings.data" :key="item.original">
      <div class="card">
        <div class="card-header">
          <h5 class="title">Keywords to monitor for {{ item.original }}</h5>
          <label
            >Each keyword is a separate regex. Creating short regex will
            generate false positive. TIP: Make sure to add the brandname and
            words used in logins subdomains
          </label>
        </div>
        <div class="card-body">
          <v-row>
            <v-col lg="11">
              <v-text-field v-model="keyword[index_domain]" solo>
              </v-text-field>
            </v-col>
            <v-col lg="1">
              <v-btn
                @click="addKeyword(keyword[index_domain], index_domain)"
                outlined
                dark
                class="btn btn-fill btn-primary"
                ><v-icon class="fab">mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-chip
                v-for="(keyword, i) in item.keywords"
                :key="i"
                close
                @click:close="removeKeyword(keyword, index_domain)"
                style="margin-left: 3px"
                active
                >{{ keyword }}
              </v-chip>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <v-row>
      <v-col lg="12">
        <v-btn
          v-on:click="savePluginSettings()"
          outlined
          dark
          class="float-right btn btn-fill btn-primary"
          ><v-icon class="fab">mdi-content-save</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>


<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
import DomainListDropdown from "./DomainListDropdown.vue";
export default {
  name: "NewRegiste",
  data: function () {
    return {
      alertError: false,
      alertSuccess: false,
      userInfo: this.$store.state.cognitoInfo,
      keyword: [],
      domains: [],
      settings: {},
      active_domain: this.$store.getters.activeDomain,
    };
  },
  created() {
    this.getPluginSettings(this.id);
  },
  computed: {
    activeDomain: function () {
      return this.$store.state.activeDomain;
    },
  },
  methods: {
    getPluginSettings(pid) {
      let self = this;
      PhishingApi.getPluginSettings(pid).then((response) => {
        console.log(response.settings.data);
        if (Object.keys(response.settings.data).length === 0) {
          self.settings = response.settings;
          self.initialiseSettings();
          console.log(self.settings);
        } else self.settings = response.settings;
      });
    },

    getReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },

    initialiseSettings() {
      let self = this;
      PhishingApi.getSettingsDetails()
        .then(function (response) {
          console.log(response.domains);

          response.domains.forEach((element) => {
            let domain = {};
            console.log(self.settings);
            domain["original"] = element;
            domain["keywords"] = [];
            self.settings["data"].push(domain);
          });

          console.log(self.settings);
        })
        .catch(function (error) {
          self.alertError = true;
          console.log(error);
        });
    },

    addKeyword(keyword, index) {
      console.log(this.settings);
      this.settings.data[index].keywords.push(keyword);
    },

    removeKeyword(keyword, index) {
      this.settings.data[index].keywords = this.settings.data[
        index
      ].keywords.filter((x) => x != keyword);
    },

    savePluginSettings() {
      let self = this;
      let data = JSON.stringify(this.settings.data);

      PhishingApi.setPluginSettings(this.id, data)
        .then(function (response) {
          self.alertSuccess = true;
        })
        .catch(function (error) {
          self.alertError = true;
          console.log(error);
        });
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
  },
  components: {
    DomainListDropdown,
  },
  props: ["id"],
};
</script>

<!-- Style -->
<style>
</style>